import {Component, OnInit}        from '@angular/core';
import {NavController}            from '@ionic/angular';
import {ActivatedRoute, Router}   from '@angular/router';
import {DataStore, SortDirection} from '@aws-amplify/datastore';
import {Faq}                      from '../../models';
import {PredicateAll}             from '@aws-amplify/datastore/lib-esm/predicates';
import {Predicates}               from 'aws-amplify';
import {SessionService}           from "../services/session.service";

@Component({
    selector: 'app-faq',
    templateUrl: './faq.page.html',
    styleUrls: ['./faq.page.scss'],
})
export class FaqPage implements OnInit {
    category: any;
    faqs: Faq[];
    searchWord = '';

    constructor(private route: ActivatedRoute, private router: Router, private navController: NavController,
                public sessionService: SessionService

                ) {
        this.route.queryParams.subscribe(async (params) => {
            if (this.router.getCurrentNavigation().extras.state) {
                this.category = this.router.getCurrentNavigation().extras.state.user;
                await this.laodCategory();


            }
        });
    }

    ngOnInit() {
        //  await DataStore.delete(Faq, Predicates.ALL);
    }

    async laodCategory() {

        this.faqs = await DataStore.query(Faq, s => s.category('eq', this.category), {
            sort: l => l.order(SortDirection.ASCENDING),
        });
        
    }

    back() {
        this.navController.back();
    }

    async searchCat() {
        
        if (this.searchWord != '') {
            this.faqs = await DataStore.query(Faq, s => s.category('eq', this.category),
                {
                    sort: l => l.order(SortDirection.ASCENDING),
                });
            let f = this.faqs.filter(x => x.answer?.toLocaleLowerCase().includes(this.searchWord.toLocaleLowerCase())
                || x.question?.toLocaleLowerCase().includes(this.searchWord.toLocaleLowerCase()));
            this.faqs = f;
        } else {
            this.faqs = await DataStore.query(Faq, s => s.category('eq', this.category),
                {
                    sort: l => l.order(SortDirection.ASCENDING),
                });
        }
    }
}
